import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * HomePage — `/`. Landing screen with the wordmark, tagline, and a single
 * "Take today's kick" CTA into /play.
 *
 * UserPill is no longer mounted here — it's rendered globally in the
 * RootLayout's fixed top-right slot, which covers every route except /play
 * (see GlobalUserPill).
 */
export function HomePage() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-6 p-6">
      <h1 className="text-5xl font-bold tracking-tight">{t("app.name")}</h1>
      <p className="text-lg opacity-80">{t("app.tagline")}</p>
      <Link
        to="/play"
        className="rounded-full bg-white/10 px-8 py-3 text-lg font-semibold backdrop-blur hover:bg-white/20"
      >
        {t("app.play_today")}
      </Link>
    </main>
  );
}
